module.exports = __webpack_public_path__ + "img/A58A1898.f6794011.jpg";